// extracted by mini-css-extract-plugin
export default {"Slider":"Slider_Slider__Brh1D","Title":"Slider_Title__FhW5a"};